/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * TAF Delivery API
 * OpenAPI spec version: 1.0
 */

export type CoursePageContentModelContentType = typeof CoursePageContentModelContentType[keyof typeof CoursePageContentModelContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CoursePageContentModelContentType = {
  coursePage: 'coursePage',
} as const;
